import { all, fork } from 'redux-saga/effects';
import navigationSaga from './navigation';

export default function* headerSaga() {
  yield all([fork(navigationSaga)]);
}
